import { FC } from 'react'
import { PageProps } from './Page1'
import Letterhead from './Letterhead'

const placeholder = (value?: string | null) => value?.trim() || '-----------'

const Page3: FC<PageProps> = ({ data }) => {
  return (
    <Letterhead data={data} pageNumber={3}>
      <p className="text">
        تبصره ۶: شماره ‌حساب، شماره کارت و شماره شبا حتماً می بایست برای یک حساب
        واحد در یک بانک واحد و به نام پذیرنده باشد و نمی توان چند شماره‌حساب
        برای پرداختی‌ها در این قسمت ثبت کرد. بدیهی است که تمام مسئولیت در
        واردکردن اطلاعات حساب در قسمت فوق به عهده پذیرنده می باشد.
      </p>
      <p className="text">
        ۳-۶ تنها شخص صاحب امضا در قرارداد حاضر می‌تواند از طریق ارسال نامه کتبی
        به آپولون شماره‌ حساب را تغییر دهد.
      </p>
      <p className="text">
        ۴-۶ لیست ریز صورت‌حساب سفارشات پذیرنده در هنگام تسویه‌حساب به آدرس ایمیل{' '}
        <span className="font-bold">{placeholder(data?.email)}</span> ارسال
        خواهد شد.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۷)</p>
      <p className="mb-2 text-lg font-bold">تعهدات آپولون</p>
      <p className="text">
        ۱-۷ آپولون متعهد می‌شود با فرض قانونی بودن فعالیت های پذیرنده (از جمله
        مالکیت و یا اختیار قطعی و قانونی بر فروشگاه، برند، کالاها و خدمات ارائه
        شده) نسبت به معرفی پذیرنده و کالا و خدمات ارائه شده توسط ایشان در رسانه
        ها و بستر پلتفرم آپولون اقدام نماید.
      </p>
      <p className="text">
        تبصره ۷: بدیهی است رعایت کلیه قوانین، مقررات و ضوابط و دستورالعمل های
        مراجع ذی‌ربط در خصوص محصولات و خدمات عرضه شده به عهده پذیرنده بوده و
        مشارٌالیه چه در زمان اعتبار این قرارداد و چه بعد از آن، در صورت هرگونه
        شکایت و اعتراض، مسئول و پاسخگو خواهد بود. آپولون هیچ مسئولیتی در مورد
        مالکیت، کیفیت و یا نحوه تولید محصولات و ارائه خدمات و یا عدم رعایت
        قوانین و مقررات از سوی پذیرنده را نداشته و نخواهد داشت.
      </p>
      <p className="text">
        ۲-۷ آپولون متعهد می‌شود تمام مستندات فنی مورد نیاز جهت راه اندازی درگاه
        پرداخت اعتباری آپولون را در اختیار پذیرنده قرار دهد. همچنین کلیه
        آموزش‌های مورد نیاز برای راه اندازی سرویس اعتباری آپولون، به پذیرنده
        ارائه خواهد شد و پشتیبانی فنی لازم از پذیرنده صورت خواهد گرفت.
      </p>
      <p className="text">
        ۳-۷ آپولون متعهد می‌گردد یک شماره تلفن پشتیبانی جهت پاسخگویی به سوالات
        پذیرنده در مورد سرویس اعتباری آپولون به پذیرنده اعلام کند.
      </p>
      <p className="text">
        ۴-۷ آپولون متعهد می‌گردد مبالغ حاصل از فروش را بر اساس ماده ۶ با پذیرنده
        تسویه نماید.
      </p>
      <p className="text">
        ۵-۷ آپولون متعهد است شرایط و نحوه استفاده از سرویس اعتباری آپولون در
        شبکه ی پذیرندگان اعتباری آپولون را به کاربران آپولون ارائه دهد.
      </p>
      <p className="text">
        ۶-۷ ریسک عدم بازپرداخت بدهی کاربران در خصوص خریدهای اعتباری موضوع این
        قرارداد بر عهده آپولون است و پذیرنده مسئولیتی در قبال آن ندارد.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۸)</p>
      <p className="mb-2 text-lg font-bold">تعهدات پذیرنده</p>
      <p className="text">
        ۱-۸ پذیرنده متعهد می‌شود امکان خرید خدمات و کالاها و سرویس‌های توافق شده
        در قرارداد را از طریق درگاه پرداخت اعتباری آپولون طبق دستورالعمل‌های
        ارسالی از طرف آپولون فراهم کند.
      </p>
      <p className="text">
        ۲-۸ پذیرنده متعهد می‌شود مسئولیت اتصال کلیه سخت افزارها و نرم افزارهای
        خود به پلتفرم آپولون را بپذیرد.
      </p>
    </Letterhead>
  )
}

export default Page3
